//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: ''
    },
    uploader: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      _unmounted: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    this._unmounted = true;
  },
  methods: {
    _onFilesSelected: function _onFilesSelected(e) {
      this.uploader.methods.addFiles(e.target);
    }
  }
};